import React, { useMemo } from 'react';
import { useTeamRegistrationStore } from '../../../store/teamRegistrationStore';

const NoParticipationBadge: React.FC = () => {
    const teams = useTeamRegistrationStore((state) => state.teams);
    const setTeams = useTeamRegistrationStore((state) => state.setTeams);

    const shouldShow = useMemo(() => {
        return (teams || []).some((t) => (t.selectedTeams ?? null) !== 0);
    }, [teams]);

    if (!shouldShow) return null;

    return (
        <div
            className="border cursor-pointer hover:border-red-600 font-medium border-red-500 bg-white rounded-full px-2 py-1 text-xs text-red-500"
            onClick={() => {
                setTeams(teams.map((t) => ({ ...t, selectedTeams: 0 })));
            }}
        >
            Alle Mannschaften abmelden
        </div>
    );
};

export default NoParticipationBadge;


